import { Component, ViewEncapsulation } from '@angular/core';
import { PanelContainerComponent } from '../../../shared/content-panels';
import { PanelHeaderComponent } from '../../../shared/content-panels';
import { CorpAdminConstants } from './models/constants/corp-admin.constants';
import { PanelBodyComponent } from '../../../shared/content-panels/panel-body.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatChip } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { CorpAdminService } from './services/corp-admin.service';
import { map } from 'rxjs/internal/operators/map';
import { QBuiltInspectorService } from 'src/app/qbuilt-inspector/services/qbuilit-inspector.service';
import { SpinnerService, ThemeService } from 'src/app/shared/services';

@Component({
  selector: 'task-management',
  imports: [
    PanelContainerComponent,
    PanelHeaderComponent,
    PanelBodyComponent,
    CommonModule,
    MatIconModule,
    MatTable,
    MatButtonModule,
    MatTableModule,
    MatChip,
    MatTooltipModule,
  ],
  templateUrl: './task-management.component.html',
  styleUrl: './task-management.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
})
export class TaskManagementComponent {
  tableColumns: string[] = [
    'itemName',
    'category',
    'creationDate',
    'required',
    'action',
  ];
  dataSource = new MatTableDataSource<any>([]);
  emptyData = new MatTableDataSource([{ empty: 'row' }]);

  departments: any[] = [];

  constructor(
    public corpAdminConstants: CorpAdminConstants,
    private router: Router,
    private corpAdminService: CorpAdminService,
    private qbuiltInspectorService: QBuiltInspectorService,
    private spinnerService: SpinnerService,
  ) {}

  ngOnInit(): void {
    this.spinnerService.show();
    //populate depts here in local storage
    this.getDepartmentData();
    this.loadData();
  }

  //calls the corp admin service to get all configured tasks and loads them into the table data source
  loadData() {
    //set up task classifcations for save and edit
    this.corpAdminService
      .getAllTaskClassifications()
      .subscribe((response: any) => {
        localStorage.setItem(
          'taskClassifications',
          JSON.stringify(response.data.GetTaskClassifications),
        );
      });

    this.corpAdminService.getAllConfiguredTasks();
    this.corpAdminService.configuredTasks$.subscribe((tasks) => {
      localStorage.setItem(
        'configuredTasks',
        JSON.stringify(tasks.GetConfiguredTasks),
      );
      this.dataSource = tasks.GetConfiguredTasks || [];
      this.spinnerService.hide();
    });
  }

  //get list of departments from backend
  getDepartmentData() {
    this.qbuiltInspectorService.departments$.subscribe((data) => {
      if (data) {
        this.departments = data;
        localStorage.setItem('departments', JSON.stringify(data));
      }
    });
    this.qbuiltInspectorService.getInspectionDepartments();
  }

  //add new task button
  addNewTask() {
    //console.log('add new task button clicked');
    this.router.navigate(['/corp-admin/task-management/new-task']);
  }

  //edit Task button
  editTask(element: any) {
    if (element) {
      let editDeptList = this.formatEditDept(element.TaskDepartments || []);
      sessionStorage.setItem(
        'taskFormGroup',
        JSON.stringify({
          taskName: element.InspectionTask.Name,
          required: element.InspectionTask.IsRequired,
          cciToggle:
            element.TaskClassificationAssignments?.some(
              (assignment: any) => assignment.ClassificationName === 'CCI',
            ) || false,
          cciCode:
            element.TaskClassificationAssignments?.find(
              (assignment: any) => assignment.ClassificationName === 'CCI',
            )?.ClassificationCode[0] || '',
          aocToggle:
            element.TaskClassificationAssignments?.some(
              (assignment: any) => assignment.ClassificationName === 'AOC',
            ) || false,
          aocCode:
            element.TaskClassificationAssignments?.find(
              (assignment: any) => assignment.ClassificationName === 'AOC',
            )?.ClassificationCode[0] || '',
          cqiToggle:
            element.TaskClassificationAssignments?.some(
              (assignment: any) => assignment.ClassificationName === 'CQI',
            ) || false,
          cqiCode:
            element.TaskClassificationAssignments?.find(
              (assignment: any) => assignment.ClassificationName === 'CQI',
            )?.ClassificationCode[0] || '',
          qsiToggle:
            element.TaskClassificationAssignments?.some(
              (assignment: any) => assignment.ClassificationName === 'QSI',
            ) || false,
          qsiCode:
            element.TaskClassificationAssignments?.find(
              (assignment: any) => assignment.ClassificationName === 'QSI',
            )?.ClassificationCode[0] || '',
          ebuiltToggle:
            element.TaskClassificationAssignments?.some(
              (assignment: any) => assignment.ClassificationName === 'eBuilt',
            ) || false,
          ebuiltCode:
            element.TaskClassificationAssignments?.find(
              (assignment: any) => assignment.ClassificationName === 'eBuilt',
            )?.ClassificationCode[0] || '',
          ebuiltPlusToggle:
            element.TaskClassificationAssignments?.some(
              (assignment: any) =>
                assignment.ClassificationName === 'eBuilt Plus',
            ) || false,
          ebuiltPlusCode:
            element.TaskClassificationAssignments?.find(
              (assignment: any) =>
                assignment.ClassificationName === 'eBuilt Plus',
            )?.ClassificationCode[0] || '',
          departments: editDeptList || [],
          primaryDeptId:
            element.TaskDepartments?.find((dept: any) => dept.IsPrimary)
              ?.DepartmentId || '',
          creationDate: element.InspectionTask.CreatedOn,
        }),
      );
    }

    this.router.navigate([
      `/corp-admin/task-management/edit-task/${element.InspectionTask.Id}`,
    ]);
  }

  //formats dept data before landing on edit page to prevent issues with drag/drop data later
  formatEditDept(deptList: any[]) {
    this.departments = localStorage.getItem('departments')
      ? JSON.parse(localStorage.getItem('departments'))
      : [];
    let formattedList = deptList.map((dept) => {
      let fullDeptInfo = this.departments.find(
        (d) => d.Id === dept.DepartmentId,
      );
      return {
        Name: fullDeptInfo ? fullDeptInfo.Name : 'Unknown Department',
        Id: dept.DepartmentId,
      };
    });

    return formattedList;
  }
}
